import { useParams } from 'react-router';
import { Col, Container, Row } from 'reactstrap';
import { StudentRiskEvaluationSessionsDataLoader } from './loaders/StudentRiskEvaluationSessionsDataLoader';
import StudentRiskEvaluationSessionsFilters from './parts/StudentRiskEvaluationSessionsFilters';
import StudentRiskEvaluationSessionsTable from './parts/StudentRiskEvaluationSessionsTable';
import { StudentRiskEvaluationSessionsParams } from './types';
const StudentRiskEvaluationSessions = () => {
  const params = useParams<StudentRiskEvaluationSessionsParams>();

  return (
    <div className="w-100 d-flex flex-wrap justify-content-center">
      <StudentRiskEvaluationSessionsDataLoader
        defaultQuery={{ ...params, items_per_page: 10, page: 1 }}
        fetchImmediately
      >
        <StudentRiskEvaluationSessionsFilters />
        <Container fluid>
          <Row>
            <Col xs={12}>
              <StudentRiskEvaluationSessionsTable />
            </Col>
          </Row>
        </Container>
      </StudentRiskEvaluationSessionsDataLoader>
    </div>
  );
};

export default StudentRiskEvaluationSessions;
